import { jobApiClient } from "utils";
import {
  FetchConnectionPayload,
} from "types";

export const fetchConnection = async (payload: FetchConnectionPayload) => {
    return await jobApiClient.post<string>("/connection/fetch", payload);
  };
  